"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdPlatformKey = void 0;
const immutable_1 = require("immutable");
const AdPlatformKey_1 = require("../AdPlatformKey");
const AdAnalyticsMedia_1 = require("./AdAnalyticsMedia");
class AdAnalyticsPlatform {
    constructor({ key, name, networks }) {
        this.toJSON = () => ({
            key: this.key,
            name: this.name,
            networks: this.networks !== undefined ? this.networks.toJSON() : undefined,
        });
        this.key = key;
        this.name = name;
        this.networks = networks;
    }
}
AdAnalyticsPlatform.fromJSON = (json) => {
    const { key, name, networks } = Object.assign({}, json);
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    if (networks !== undefined && !Array.isArray(networks))
        throw new Error('.networks must be an array');
    const _key = deserializeToAdPlatformKey(key);
    const _networks = networks ? immutable_1.List(networks).map(network => AdAnalyticsMedia_1.default.fromJSON(network)) : undefined;
    return new AdAnalyticsPlatform({
        key: _key,
        name: name,
        networks: _networks,
    });
};
const deserializeToAdPlatformKey = (str) => {
    if (Object.keys(exports.AdPlatformKey).indexOf(str) === -1) {
        throw new Error(`str must be a one of ${Object.keys(exports.AdPlatformKey).join(', ')}`);
    }
    return str;
};
exports.AdPlatformKey = {
    facebook: 'facebook',
    google: 'google',
    amazon: 'amazon',
    yahoo: 'yahoo',
    tiktok: 'tiktok',
};
exports.default = AdAnalyticsPlatform;
